export const SHOW_PAGE_DATOS_FACTURACION = 'UPDATE_DATOS_FACTURACION'
export const HIDE_PAGE_DATOS_FACTURACION = 'HIDE_PAGE_DATOS_FACTURACION'

export interface ShowPageDatosFacturacion {
  type: typeof SHOW_PAGE_DATOS_FACTURACION
  payload: null
}

export interface HidePageDatosFacturacion {
  type: typeof HIDE_PAGE_DATOS_FACTURACION
  payload: null
}

export interface DatosFacturacionState {
  validRoute: boolean
}

export const InitialState: DatosFacturacionState = {
  validRoute: false,
}

export type DatosFacturacionActions = ShowPageDatosFacturacion | HidePageDatosFacturacion
